import { Column } from '@/components'
import { ThemeColor } from '@/enums'
import { themeColor } from '@/utils'
import styled from 'styled-components'

export const Container = styled(Column)`
  grid-column: col-start 3 / span 9;
  gap: 16px;

  &:has(table) {
    grid-column: col-start 3 / span 10;
  }

  @media (max-width: 655px) {
    grid-column: col-start / span 2 !important;
  }
`

export const ErrorContainer = styled(Column)`
  padding: 48px 0;
  gap: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${themeColor(ThemeColor.danger1)};
`
